module.exports = __webpack_public_path__ + "static/media/energy_card_red.52abd6ed.svg";